import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Rotas de /parcerias-proprias e /parcerias-exclusivas ficam no app-routing
// (redirect para o portal). Este módulo permanece só para componentes legados.
export const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OwnPartnershipRoutingModule {}
